import { render, staticRenderFns } from "./hangNewPrice.vue?vue&type=template&id=a94b0b1c&scoped=true"
import script from "./hangNewPrice.vue?vue&type=script&lang=js"
export * from "./hangNewPrice.vue?vue&type=script&lang=js"
import style0 from "./hangNewPrice.vue?vue&type=style&index=0&id=a94b0b1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a94b0b1c",
  null
  
)

export default component.exports